import { Expose } from "class-transformer";

export class CreateProjectHasContactDto {
  @Expose()
  projectId: string;

  @Expose()
  contactId: string;
}
